import { FastField, getIn, useFormikContext } from "formik";
import React, { useEffect, useRef } from "react";
import { theme } from "../../../Customization/Theme";
import {
  StyledInputField,
  StyledWidgetInputBox,
} from "../../Styles/StyledForms";
import { useAppSelector } from "../../../Store";

import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import AppErrorMessage from "./AppErrorMessage";
import AppSendSubmitButton from "./AppSendSubmitButton";
import AppVoiceButton from "./AppVoiceButton";

interface Props {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  showVoiceButton?: boolean;
  [otherProps: string]: any;
  ref?: any;
}

const AppFlowEmailField: React.FC<Props> = ({
  name = "email",
  label = "Enter your email",
  children,
  showVoiceButton = false,
  ...otherProps
}) => {
  const { errors, touched, values, handleChange, setFieldValue } = useFormikContext<any>();
  const { typingStatus } = useAppSelector(allMessagesStore);

  const inputRef: any = useRef<any>();

  useEffect(() => {
    if (inputRef?.current && !typingStatus) {
      inputRef?.current?.focus();
    }
  }, [inputRef, typingStatus]);

  const handleVoiceInput = (text: string) => {
    // Format the email by handling spoken variations
    const formattedEmail = text
      .toLowerCase()
      .replace(/\s+/g, '') // Remove all spaces
      .replace(/at\s*the\s*rate/g, '@') // Handle 'at the rate' case
      .replace(/at\s*rate/g, '@') // Handle 'at rate' case
      .replace(/at/g, '@') // Replace 'at' with @
      .replace(/dot/g, '.') // Replace 'dot' with .
      .replace(/[^a-zA-Z0-9@._-]/g, ''); // Remove any other special characters
    
    setFieldValue(name, formattedEmail);
  };

  const emailValue = getIn(values, name) || "";

  return (
    <StyledWidgetInputBox
      disabled={typingStatus ? true : false}
      error={getIn(errors, name) && getIn(touched, name)}
    >
      <FastField name={name}>
        {({ field }: any) => (
          <StyledInputField
            {...otherProps}
            {...field}
            // value={getIn(values, name) || ""}
            value={emailValue}
            onChange={(e: any) => {
              handleChange(e);
            }}
            placeholder={label}
            autoFocus={true}
          // disabled={typingStatus ? true : false}
          />
        )}
      </FastField>

      {showVoiceButton && !emailValue ? (
        getIn(values, name)?.length > 0 ? (
          <AppSendSubmitButton />
        ) : (
          <AppVoiceButton onVoiceInput={handleVoiceInput} />
        )
      ) : (
        <AppSendSubmitButton />
      )}

      <AppErrorMessage
        error={getIn(errors, name)}
        visible={getIn(touched, name)}
      />
    </StyledWidgetInputBox>
  );
};

export default AppFlowEmailField;
